import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { List, ListItem, ListItemText, Divider, Collapse, Typography } from '@material-ui/core';
import IconExpandLess from '@material-ui/icons/ExpandLess';
import IconExpandMore from '@material-ui/icons/ExpandMore';

const useStyles = makeStyles({
    link: {
        paddingLeft: "0px !important",
        textDecoration: 'none',
        textTransform: 'none'
    }
});

const MenuItemMovil = (props) => {
    const { url, title, children: items = [], toggleDrawer } = props;
    const [open, setOpen] = React.useState(false);

    const handleClickMenu = () => setOpen(!open);

    const isExpandable = items && items.length > 0;
    const showMoreIcon = isExpandable && !open;
    const showLessIcon = isExpandable && open;
    const lastItem = !showMoreIcon && !showLessIcon;

    const MenuItemRoot = () => {
        const classes = useStyles();
        const conEnlace = lastItem && url;
        const backgroundColor = (!isExpandable && lastItem) && conEnlace ? '#fff' : '';

        return (
            <ListItem button onClick={handleClickMenu} style={{ backgroundColor: backgroundColor}}>
                {
                    (conEnlace &&
                        <a
                            onClick={toggleDrawer}
                            href={`${url}`}
                            className={`itemSubmenu itemMenuMovil ${classes.link}`}
                            style={{ color: 'rgb(17, 111, 92)' }}
                        >{title}</a>)
                    || <ListItemText
                        disableTypography
                        primary={
                            <Typography
                                type="body2"
                                style={{
                                    color: showLessIcon ? '#116F5C' : 'default',
                                    fontWeight: showLessIcon ? 'bolder' : 'normal'
                                }}
                            >{title}</Typography>
                        }
                    />
                }

                {/* Display the expand menu if the item has children */}
                {showMoreIcon && <IconExpandMore style={{fontSize:"35px"}} />}
                {showLessIcon && <IconExpandLess style={{fontSize:"35px"}} />}
            </ListItem>
        )
    }

    const MenuItemChildren = isExpandable ? (
        <Collapse in={open} timeout="auto" unmountOnExit>
            <Divider />
            <Divider />
            <List component="div" disablePadding style={{ backgroundColor: '#F0F0F0' }}>
                {
                    items.map((item, index) => (
                        <MenuItemMovil toggleDrawer={toggleDrawer} {...item} key={`subMenuItem-${index}`} />
                    ))
                }
            </List>
        </Collapse>
    ) : null;

    return (
        <>
            <MenuItemRoot />
            {MenuItemChildren}
        </>
    );
}

export default MenuItemMovil;